/**
 * As the MediumEditor module does not compile out side the browser, due to the usage of document and other browser 
 * specific code, this class is used as a dummy substitute when compiling to SSR.
 */
export class MediumEditor {
    private content = "";
    constructor(editorDiv: any, MediumEditorOptions: any) {
        // console.log("Ssr Medium Editor Dummy initialized");
    }

    public setContent(content: string) {
        this.content = content;
    }

    public getContent() {
        return this.content;
    }

    public subscribe(evType: string, callback: (ev: InputEvent, editElement: HTMLElement) => void) {
    }
}

export default MediumEditor;
